import { Box, Flex, Text } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { useTranslation } from 'react-i18next';
import BlockContent from '@sanity/block-content-to-react';

import React, { FC } from 'react';

//region styled

const Wrapper = styled(Flex)`
  flex-direction: column;
  margin-bottom: 45px;
  padding: 20px;
`;

const ProjectOwnerWrapper = styled(Flex)`
  justify-content: space-between;
  margin: 30px 0 0;
`;

//endregion

const ProjectBlurb: FC<{ project?: Project }> = ({ project }) => {
  const { t } = useTranslation('projects');

  return (
    <Wrapper layerStyle="projects.projectBlurb.wrapper">
      <Text layerStyle="projects.projectBlurb.descriptionTitle" as="h2" fontFamily="heading">
        {project?.subtitle}
      </Text>

      <Box layerStyle="projects.projectBlurb.description">
        <BlockContent blocks={project?.description} />
      </Box>
      <ProjectOwnerWrapper>
        <Text layerStyle="projects.projectBlurb.projectOwnerTitle">{t('projectOwner')}</Text>
        <Text layerStyle="projects.projectBlurb.projectOwnerLabel">{project?.projectOwner}</Text>
      </ProjectOwnerWrapper>
    </Wrapper>
  );
};

export default ProjectBlurb;
